export default __webpack_public_path__ + "static/media/isotipo-koulutus.b80a88d1.svg";